import styled from "styled-components";
import { PaginationItem, Select } from "@mui/material";

import { breakpoints } from "@/styles/breakpoints";

export const StyledPagination = styled.div`
    position: relative;
    padding-top: 10px;
    margin: 30px 0;
    border-top: 1px solid var(--color-grey-700);

    .pagination-ul {
        justify-content: center;
    }
`;

export const StyledPaginationItem = styled(PaginationItem)`
    color: var(--color-grey-800);

    &.page {
        font-size: var(--size-14);
        font-weight: bold;
        line-height: 19px;
    }
    .icon {
        font-size: var(--size-24);
        color: var(--color-primary);
    }
    &.selected {
        position: relative;
        color: var(--color-secondary) !important;
        background-color: transparent !important;

        &::before {
            position: absolute;
            top: -11px;
            width: calc(100% + 0px);
            height: 0;
            content: "";
            background-color: var(--color-secondary);
            border: 1px solid var(--color-secondary);
            border-radius: var(--radius-10);
        }
    }
`;

export const StyledPageSize = styled.div`
    position: absolute;
    top: calc(50% - 10px);
    right: 30px;
    font-size: var(--size-14);

    @media ${breakpoints.xs} {
        position: relative;
        right: 0;
        float: right;
        font-size: var(--size-12);
    }
`;

export const PageSizeLabel = styled.span`
    margin-right: 5px;
    font-weight: 400;
    color: var(--color-grey-800);
`;

export const StyledSelect = styled(Select)`
    .select {
        padding: 0 24px 0 8px;
        min-height: 15px;
        font-size: var(--size-14);
        font-weight: bold;
        color: var(--color-secondary);

        @media ${breakpoints.xs} {
            font-size: var(--size-12);
        }
    }

    &::before,
    &::after {
        display: none;
    }
`;
